import postAPI from './postAPI.js'

export default async function postDeleteTaskMessage(id) {
    const data = await postAPI('taskmessages/delete', { id });
    return data;
}
